module.exports = __webpack_public_path__ + "img/langeland.be799fed.jpg";